import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

function TableDataGrid({ columns = [], sx, fillHeight = false, ...props }) {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const shouldFillHeight = fillHeight || !isMobile;
  const isRtl = i18n.language?.startsWith("ar");
  const sizedColumns = columns.map((column) => {
    const headerText = typeof column.headerName === "string" ? column.headerName : "";
    const headerWidth = Math.max(80, Math.ceil(headerText.length * 9) + 32);

    return {
      ...column,
      minWidth: Math.max(column.minWidth || 0, headerWidth),
      ...(column.flex ? {} : { width: Math.max(column.width || 100, headerWidth) }),
    };
  });

  const gridColumns = isRtl ? [...sizedColumns].reverse() : sizedColumns;
  const selectionColumnWidth = props.checkboxSelection ? 52 : 0;
  const gridMinWidth = Math.max(
    isMobile ? 720 : 1200,
    selectionColumnWidth + sizedColumns.reduce((total, column) => total + (column.width || column.minWidth || 100), 0),
  );

  return (
    <Box className="portal-data-grid" dir={isRtl ? "rtl" : "ltr"} sx={{ width: "100%", minWidth: 0, height: shouldFillHeight ? "100%" : "auto", overflowX: "auto", direction: isRtl ? "rtl" : "ltr" }}>
      <DataGrid
        {...props}
        dir="ltr"
        columns={gridColumns}
        autoHeight={!shouldFillHeight}
        headerHeight={56}
        disableColumnResize
        sx={{
          background: "white",
          minWidth: gridMinWidth,
          direction: "ltr",
          border: "1px solid #dbe3e6",
          borderRadius: "12px",
          overflow: "hidden",
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          "& .MuiDataGrid-virtualScroller": { overflowX: "hidden" },
          ...(isRtl && {
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
              direction: "rtl",
              textAlign: "right",
            },
          }),
          ...sx,
        }}
      />
    </Box>
  );
}

export default TableDataGrid;
